var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71835 1.27441C8.76432 5.46078 5.46079 8.76431 1.27442 9.71834C0.533975 9.88566 0 10.5264 0 11.2847V14.4031C0 15.3998 0.900639 16.1581 1.88315 15.9801C4.40352 15.528 6.73521 14.5348 8.7572 13.1251C10.4588 11.9397 11.9397 10.4588 13.1251 8.75719C14.7662 6.40414 15.8448 3.63103 16.1581 0.633645C16.1937 0.29546 15.9338 0.00355773 15.5956 0.00355773H11.2882C10.5264 -2.10369e-06 9.88567 0.533965 9.71835 1.27441Z",
    fill: "#5438FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71835 1.27441C8.76432 5.46078 5.46079 8.76431 1.27442 9.71834C0.533975 9.88566 0 10.5264 0 11.2847V14.4031C0 15.3998 0.900639 16.1581 1.88315 15.9801C4.40352 15.528 6.73521 14.5348 8.7572 13.1251C10.4588 11.9397 11.9397 10.4588 13.1251 8.75719C14.7662 6.40414 15.8448 3.63103 16.1581 0.633645C16.1937 0.29546 15.9338 0.00355773 15.5956 0.00355773H11.2882C10.5264 -2.10369e-06 9.88567 0.533965 9.71835 1.27441Z",
    fill: "url(#paint0_linear_1422_8114)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1251 16.9305C11.9397 15.2325 10.4588 13.748 8.75721 12.5662C6.73522 11.1529 4.40353 10.1597 1.88316 9.7112C0.904209 9.53676 0.00357056 10.2914 0.00357056 11.2882V14.4066C0.00357056 15.1649 0.537546 15.8056 1.27799 15.9729C5.46792 16.9234 8.77145 20.227 9.72192 24.4169C9.88924 25.1573 10.53 25.6913 11.2883 25.6913H15.5957C15.9338 25.6913 16.1937 25.3958 16.1581 25.0612C15.8413 22.0603 14.7662 19.2836 13.1251 16.9305Z",
    fill: "#5438FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1251 16.9305C11.9397 15.2325 10.4588 13.748 8.75721 12.5662C6.73522 11.1529 4.40353 10.1597 1.88316 9.7112C0.904209 9.53676 0.00357056 10.2914 0.00357056 11.2882V14.4066C0.00357056 15.1649 0.537546 15.8056 1.27799 15.9729C5.46792 16.9234 8.77145 20.227 9.72192 24.4169C9.88924 25.1573 10.53 25.6913 11.2883 25.6913H15.5957C15.9338 25.6913 16.1937 25.3958 16.1581 25.0612C15.8413 22.0603 14.7662 19.2836 13.1251 16.9305Z",
    fill: "url(#paint1_linear_1422_8114)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8383 25.0577C17.8028 25.3923 18.0626 25.6878 18.4008 25.6878H22.7082C23.4665 25.6878 24.1072 25.1502 24.2745 24.4133C25.225 20.2234 28.5285 16.9234 32.7185 15.9694C33.4589 15.8021 33.9929 15.1613 33.9929 14.4031V11.2847C33.9929 10.2879 33.0923 9.53322 32.1133 9.70766C29.5929 10.1598 27.2612 11.153 25.2392 12.5627C23.5376 13.7445 22.0568 15.229 20.8713 16.927C19.2302 19.2836 18.1552 22.0603 17.8383 25.0577Z",
    fill: "#5438FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8383 25.0577C17.8028 25.3923 18.0626 25.6878 18.4008 25.6878H22.7082C23.4665 25.6878 24.1072 25.1502 24.2745 24.4133C25.225 20.2234 28.5285 16.9234 32.7185 15.9694C33.4589 15.8021 33.9929 15.1613 33.9929 14.4031V11.2847C33.9929 10.2879 33.0923 9.53322 32.1133 9.70766C29.5929 10.1598 27.2612 11.153 25.2392 12.5627C23.5376 13.7445 22.0568 15.229 20.8713 16.927C19.2302 19.2836 18.1552 22.0603 17.8383 25.0577Z",
    fill: "url(#paint2_linear_1422_8114)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7117 0H18.4043C18.0662 0 17.8063 0.295463 17.8419 0.630087C18.1587 3.62747 19.2338 6.40415 20.8749 8.75364C22.0603 10.4552 23.5412 11.9361 25.2428 13.1216C27.2648 14.5312 29.5965 15.5244 32.1168 15.9765C33.0958 16.151 34 15.3963 34 14.3995V11.2811C34 10.5229 33.466 9.88211 32.7256 9.7148C28.5392 8.76076 25.2357 5.45723 24.2816 1.27086C24.1108 0.533978 23.47 0 22.7117 0Z",
    fill: "#5438FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7117 0H18.4043C18.0662 0 17.8063 0.295463 17.8419 0.630087C18.1587 3.62747 19.2338 6.40415 20.8749 8.75364C22.0603 10.4552 23.5412 11.9361 25.2428 13.1216C27.2648 14.5312 29.5965 15.5244 32.1168 15.9765C33.0958 16.151 34 15.3963 34 14.3995V11.2811C34 10.5229 33.466 9.88211 32.7256 9.7148C28.5392 8.76076 25.2357 5.45723 24.2816 1.27086C24.1108 0.533978 23.47 0 22.7117 0Z",
    fill: "url(#paint3_linear_1422_8114)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1422_8114",
    x1: 16.2572,
    y1: -0.183158,
    x2: -2.92829,
    y2: 4.85497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8220FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1422_8114",
    x1: 16.2572,
    y1: 9.49931,
    x2: -2.92504,
    y2: 14.5346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8220FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1422_8114",
    x1: 34.0887,
    y1: 9.49577,
    x2: 14.9065,
    y2: 14.5311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8220FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1422_8114",
    x1: 34.0959,
    y1: -0.186688,
    x2: 14.9105,
    y2: 4.85168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8220FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo3);
export default __webpack_public_path__ + "static/media/brand-logo-3.74bc6b2a7b2c6f4a180666e0841abeb4.svg";
export { ForwardRef as ReactComponent };